import {showModal} from '../actions/show-modal';
import {PUB_SUB_CHANNEL_MODAL} from '../../../constants';
import {getModals} from '../selectors/modal-selectors';
import {MODAL_LISTENER_NAME} from '../constants';

/* When root modal loads, it fires IS_MODAL_LOADED event which is sent by pubSub to app,
   then we check if we had any modals opened while root wasn't loaded and if listener by root is
   added. If it's not added, we wait until it's added and then transmit modal it should show. */
export const publishOpenedModalsMiddleware = publicPubSub => store => {
  const getModal = () => getModals(store.getState())[0];
  const openModal = modal =>
      store.dispatch(
        showModal(modal, {
          publish: [PUB_SUB_CHANNEL_MODAL],
        }),
      );


  publicPubSub.addListenerObserver(function listen({listener}) {
    if (listener.listenerName === MODAL_LISTENER_NAME) {
      publicPubSub.removeListenerObserver(listen);
      const modal = getModal();
      modal && openModal(modal);
    }
  });

  return next => action => next(action);
};
